import { render, staticRenderFns } from "./TubingSetting.vue?vue&type=template&id=e4ebdec2&scoped=true"
import script from "./TubingSetting.vue?vue&type=script&lang=js"
export * from "./TubingSetting.vue?vue&type=script&lang=js"
import style0 from "./TubingSetting.vue?vue&type=style&index=0&id=e4ebdec2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ebdec2",
  null
  
)

export default component.exports